import React, {
  useRef,
  useImperativeHandle,
  forwardRef,
  useLayoutEffect,
  useCallback,
} from 'react';

const ListboxWithScrollPreservation = forwardRef(
  function ListboxWithScrollPreservation(props, ref) {
    const { children, onScroll, ...other } = props;
    const listRef = useRef(null);
    const scrollPositionRef = useRef(0);
    const isUserScrollingRef = useRef(false);
    const scrollTimeoutRef = useRef(null);

    useImperativeHandle(ref, () => listRef.current);

    const handleScroll = useCallback(
      (event) => {
        scrollPositionRef.current = event.currentTarget.scrollTop;
        isUserScrollingRef.current = true;

        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }
        scrollTimeoutRef.current = setTimeout(() => {
          isUserScrollingRef.current = false;
        }, 150);

        if (onScroll) onScroll(event);
      },
      [onScroll]
    );

    // Instala bloqueios em useLayoutEffect (antes do MUI)
    useLayoutEffect(() => {
      const originalScrollIntoView = Element.prototype.scrollIntoView;
      const originalScrollTo = Element.prototype.scrollTo;
      const originalScrollBy = Element.prototype.scrollBy;

      const isInsideListbox = (el) => {
        try {
          return listRef.current && listRef.current.contains(el);
        } catch {
          return false;
        }
      };

      Element.prototype.scrollIntoView = function (...args) {
        if (isInsideListbox(this)) return;
        return originalScrollIntoView.apply(this, args);
      };

      Element.prototype.scrollTo = function (...args) {
        if (isInsideListbox(this)) return;
        return originalScrollTo.apply(this, args);
      };

      Element.prototype.scrollBy = function (...args) {
        if (isInsideListbox(this)) return;
        return originalScrollBy.apply(this, args);
      };

      return () => {
        Element.prototype.scrollIntoView = originalScrollIntoView;
        Element.prototype.scrollTo = originalScrollTo;
        Element.prototype.scrollBy = originalScrollBy;
      };
    }, []);

    // Restaura a posição do scroll quando a lista muda
    useLayoutEffect(() => {
      if (listRef.current) {
        const previous = isUserScrollingRef.current;
        isUserScrollingRef.current = true;
        listRef.current.scrollTop = scrollPositionRef.current;
        isUserScrollingRef.current = previous;
      }
    }, [children]);

    return (
      <ul {...other} ref={listRef} role="listbox" onScroll={handleScroll}>
        {children}
      </ul>
    );
  }
);

export default React.memo(ListboxWithScrollPreservation);